import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseDataService, BaseTabs2Container, DefaultListTabsComponent, ModelData, ModelDataService, QueryParameter, RefreshType, Tabs2ContainerService, UserService } from 'yt-ng-framework';
import { CompanyZrcView } from './company-zrc-view-new';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';

@Component({
  selector: 'yt-company-zrc-new-tabs',
  templateUrl: './company-zrc-new-tabs.component.html'
  , providers: [
    Tabs2ContainerService
  ]
})
export class CompanyZrcNewTabsComponent extends BaseTabs2Container<CompanyZrcView> implements OnInit {

  constructor(
    public tabsContainerService2: Tabs2ContainerService<CompanyZrcView>,
    // protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected modelDataService: ModelDataService,
    protected baseDataService: BaseDataService,
  ) { 
    super(tabsContainerService2, userService);
  }

  // constructor(
  //   public tabsContainerService: Tabs2ContainerService<CompanyZrcView>,
  //   protected activatedRoute: ActivatedRoute,
  //   protected userService: UserService,
  //   protected modelDataService: ModelDataService,
  //   protected baseDataService: BaseDataService,
  // ) { 
  //   super(tabsContainerService, activatedRoute, userService);
  // }

  @ViewChild("defaultList", { static: false })
  defaultList: DefaultListTabsComponent<CompanyZrcView>;
  private _modelData: ModelData;
  @Output() Items = new EventEmitter<List<CompanyZrcView>>();
  // @Input() ParametersZrc: string;

  // private _parametersZrc: string;
  // @Input() set ParametersZrc(value: string){
  //   this._parametersZrc = value;
  //   if (value){
  //     this.modelData = this.modelDataService.GetModelDataByPath("firma-zrc");      
  //     this.loadItems(this.modelData.MainList.ModelName, this.modelData.MainList.GetName, this.getQueryParameter(), this.modelData.MainList.ShortModelClass)
  //     .subscribe((data: CompanyZrcView[]) => {
  //       this.defaultList.mainItems = List(data);
  //       this.defaultList.defaultTable.Items = List(data);
  //       // this.defaultList.defaultTable.Items.emit(this.defaultList.mainItems);
  //   })

  //   }
  //   else{
  //     if (this.defaultList)
  //       this.defaultList.mainItems = List([]);
  // }
  // }

  private _model: string;
  private _parentPropertyName:string;
  private _parentPropertyValue: number;

  @Input() set Model(value: string){
    this._model = value;
    if (this._model)
      this._modelData = this.modelDataService.GetModelDataByPath(this._model);
  }

  @Input() set ParentPropertyName(value: string){
    this._parentPropertyName = value;
  }

  @Input() set ParentPropertyValue(value: number){
    this._parentPropertyValue = value;
  }


  ngOnInit() {    
    super.ngOnInit();
    
     console.log("defaultList:", this.defaultList);
    this.tabsContainerService2.ActiveTab2.subscribe(tabID => {
      this._modelData.RefreshType = RefreshType.NoReload;
      const selectedItem = this.defaultList.mainItems.find(item => item.Selected);
      
      if (tabID === 'tbList2' && selectedItem) {
        
        console.log('[CompanyZrcNewTabsComponent] Povratak na tbList, osvežavam detalje za ID:', selectedItem.ID);
        this.tabsContainerService2.EmitItem(selectedItem);
        this._modelData.RefreshType = RefreshType.Reload;
      } else if (tabID === 'tbList2') {
        console.warn('[CompanyZrcNewTabsComponent] Povratak na tbList, ali selectedItem nije definisan');
      }
    });
    // this.defaultList.LoadMainItems(true)
   
  }
 

  private loadItems<T extends CompanyZrcView>(modelName: string, getName: string, parameters: QueryParameter[], modelClass: any){
    return this.baseDataService.Get<T>(modelName, getName, parameters, modelClass);
}

// private getQueryParameter(): QueryParameter[]{
//   let queryParameters: QueryParameter[] = [];
//   let queryParameter = new QueryParameter();
//   queryParameter.Name = "FirmaID";
//   queryParameter.Value = this._parametersZrc;
//   queryParameters.push(queryParameter);
//   return queryParameters;
// }

}
